var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronDownSidebar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9993 0C4.92427 0 -0.000732422 4.925 -0.000732422 11C-0.000732422 17.075 4.92427 22 10.9993 22C17.0743 22 21.9993 17.075 21.9993 11C21.9993 4.925 17.0743 0 10.9993 0ZM7.70627 8.793C7.51767 8.61084 7.26506 8.51005 7.00287 8.51233C6.74067 8.5146 6.48986 8.61977 6.30445 8.80518C6.11904 8.99059 6.01387 9.2414 6.01159 9.5036C6.00932 9.7658 6.11011 10.0184 6.29227 10.207L10.2923 14.207C10.4798 14.3945 10.7341 14.4998 10.9993 14.4998C11.2644 14.4998 11.5187 14.3945 11.7063 14.207L15.7063 10.207C15.8884 10.0184 15.9892 9.7658 15.9869 9.5036C15.9847 9.2414 15.8795 8.99059 15.6941 8.80518C15.5087 8.61977 15.2579 8.5146 14.9957 8.51233C14.7335 8.51005 14.4809 8.61084 14.2923 8.793L10.9993 12.086L7.70627 8.793Z",
    fill: "#424242"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDownSidebar);
export default __webpack_public_path__ + "static/media/ChevronDownSidebar.6bc9b322b0697c699c17a1e6a4671b01.svg";
export { ForwardRef as ReactComponent };